import React, { useEffect, useCallback } from 'react';
import { Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FullRedirect from './FullRedirect';


const ProtectedRoute = ({
  enter, leave, redirect = '/', name, computedMatch, ...props
}) => {
  const state = useSelector((globalState) => globalState);
  const canEnter = enter ? enter(state) : true;
  const dispatch = useDispatch();


  const { params } = computedMatch;

  const storePage = useCallback(() => {
    dispatch({
      type: 'STORE_PAGE',
      name,
      extra: {
        params,
      },
    });
  }, [name, dispatch, params]);

  useEffect(() => {
    storePage();
  }, [storePage]);


  return canEnter ? <Route {...props} /> : <FullRedirect to={redirect} />;
};

export default ProtectedRoute;
